import { ComponentProps, MutableRefObject } from "react";

type EditSubtitleProps = {
  subtitleInputRef: MutableRefObject<any>;
} & ComponentProps<"form">;

export function EditSubtitle({
  onSubmit,
  subtitleInputRef,
}: EditSubtitleProps) {
  return (
    <>
      <input type="checkbox" id="editSubtitleModal" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <form onSubmit={onSubmit}>
            <p className="font-bold text-lg">ID زیرنویس را وارد کنید</p>
            <input
              type="number"
              className="input w-full max-w-xs input-bordered mt-5"
              name="subtitle"
              required
              ref={subtitleInputRef}
            />

            <div className="modal-action">
              <div className="flex w-full justify-between mt-10">
                <label
                  htmlFor="editSubtitleModal"
                  className="btn btn-outline btn-error"
                >
                  بستن
                </label>
                <button className="btn btn-info px-10" type="submit">
                  بله
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
}
